export function slideMenuToggle() {
    const slideMenuMain = document.getElementById('slideMenu');
    const slideMenuSwitch = document.getElementById('slideMenu_switch');
    const slideMenuIcon = document.querySelectorAll('#slideMenu_switch figure')[0];


    if (slideMenuMain && slideMenuIcon){

        console.log('slideMenuJs ready')

        slideMenuSwitch.addEventListener('click',()=>{
            if(slideMenuMain.classList.contains('open')){
                slideMenuMain.classList.remove('open');
                slideMenuIcon.classList.remove('open');
                document.body.style.setProperty('overflow',null);
            }
            else{
                slideMenuMain.classList.add('open');
                slideMenuIcon.classList.add('open');
                document.body.style.setProperty('overflow','hidden');
            }
        })
    }
}